import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { ConstMessage } from "../../config/const";

export type Prop = {
  text?: string
}

export const EventParticipationModal = ({
  open,
  toggle,
  closeOnClickOutside,
  text = ConstMessage.ERR_SEARCH_ITEM_INPUT_REQUIRED
}: Prop & ModalProp) => {
  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
        <div className="px-2 pb-4 sm:p-4">
          <div className="mt-5 whitespace-pre-wrap">
            {text}
          </div>
        </div>
        <ModalFoterBox>
          <Button
            onClick={toggle}
            children={"閉じる"}
          />
        </ModalFoterBox>
      </Dialog.Panel>
    </Modal>
  );
}
